<template>
  <div class="customer-baseinfo">
    <h3>企业地址信息</h3>
    <div class="edit-btns">
      <a-button
        slot="extra"
        type="primary"
        size="default"
        @click="editBasic"
        class="margin-bottom-20"
        v-if="permissions && permissions.includes('编辑')"
      >
        编辑
      </a-button>
    </div>
    <CardEdit
      ref="formAddress"
      :source-data="sourceDataBasic"
      :schema="ADDRESS_SCHEMA"
      layout="horizontal"
      :labelCol="labelCol"
      :wrapperCol="wrapperCol"
      @handleBusiTypeChange="
        value => handleBusiTypeChange(value, 'formAddress')
      "
    >
      <!-- 联动select，具名插槽 -->
      <template v-slot:area="slotProps">
        <a-cascader
          :disabled="slotProps.disabled"
          :options="optionsArea"
          :fieldNames="fieldNames"
          change-on-select
          v-decorator="
            $decorator('area', '', [{ required: false }], {
              initialValue: defaultValue,
            })
          "
        />
      </template>
      <!-- 操作区域 -->

      <template v-slot:operate-area>
        <div v-show="basicButtonsShow" style="text-align:right">
          <a-button @click="handleCancelBasic">
            取消
          </a-button>
          <a-button
            type="primary"
            class="margin-left-10"
            @click="handleSubmitBasic"
          >
            保存
          </a-button>
        </div>
      </template>
    </CardEdit>
  </div>
</template>
<script>
import { CardEdit } from 'lxfintech-fe'
//import ExtraInfo from './ExtraInfo'
import { SCORE_CARD_SCHEMA } from '@/utils/staticData.js'
import mixin from './mixinAddr'
import { addAddress } from '../api'
import areaList from '@/utils/area.json'
import cloneDeep from 'lodash/cloneDeep'
export default {
  components: {
    CardEdit,
  },
  mixins: [mixin],
  name: 'create-form',
  props: ['permissions', 'customerDetail'],
  data() {
    return {
      visible: false,
      confirmLoading: false,
      MODAL_WIDTH: 1000,
      SCORE_CARD_SCHEMA,
      formLayout: 'horizontal',
      checkboxList: [],
      filters: [],
      destroyOnClose: true,
      activeKey: [1, 2],
      basicButtonsShow: false, //企业基本信息按钮是否展现
      businessList: [], //业务类型
      regionOptionList: [], //大区/模式 optionList
      optionsArea: [],
      fieldNames: {
        label: 'title',
        value: 'title',
        children: 'data',
      },
      defaultValue: [],
      pids: [],
    }
  },
  computed: {
    // 信用主管默认选择当前用户
  },
  created() {
    this.optionsArea = areaList.title
  },
  mounted() {
    this.query()
  },
  methods: {
    // 企业地址信息
    query() {
      for (let key in this.sourceDataBasic) {
        if (key === 'area' && this.customerDetail.base.country) {
          this.defaultValue.push(this.customerDetail.base.country)
          this.defaultValue.push(this.customerDetail.base.province)
          this.defaultValue.push(this.customerDetail.base.city)
        } else {
          if (key === 'area') {
            this.sourceDataBasic[key] = ''
          } else {
            this.sourceDataBasic[key] = this.customerDetail.base[key]
          }
        }
      }
    },

    //编辑-企业基本信息
    editBasic() {
      this.basicButtonsShow = true
      for (let key in this.ADDRESS_SCHEMA) {
        this.ADDRESS_SCHEMA[key].disabled = false
      }
    },
    // 校验 - 企业基本信息
    async validateForm() {
      try {
        var values = await this.$refs.formAddress.handleSubmit()
        const passed = !!values

        if (passed) {
          this.defaultValue = values.area
          for (let key in this.sourceDataBasic) {
            if (key != 'code') {
              this.sourceDataBasic[key] = values[key]
            }
          }

          var query = cloneDeep(this.sourceDataBasic)
          query.country = values.area[0]
          query.province = values.area[1]
          query.city = values.area[2]

          delete query.area
          return query
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 保存 - 企业基本信息
    async handleSubmitBasic() {
      var data = await this.validateForm()
      if (data) {
        addAddress(data).then(() => {
          this.$message.success('成功')
          this.basicButtonsShow = false
          // disabled
          for (let key in this.ADDRESS_SCHEMA) {
            this.ADDRESS_SCHEMA[key].disabled = true
          }
        })
      }
    },
    // 取消 - 企业基本信息
    handleCancelBasic() {
      this.$refs.formAddress.handleReset()
      this.basicButtonsShow = false
      //disabled
      for (let key in this.ADDRESS_SCHEMA) {
        this.ADDRESS_SCHEMA[key].disabled = true
      }
    },
  },
}
</script>
<style lang="less" scoped>
.customer-baseinfo {
  /deep/.margin-left-10 {
    margin-left: 10px;
  }
  .client-center-home
    /deep/
    .ant-collapse
    > .ant-collapse-item
    > .ant-collapse-header {
    line-height: 30px;
  }
  .edit-btns {
    text-align: right;
    width: 98.5%;
  }
  .margin-bottom-20 {
    margin-bottom: 20px;
  }
}
</style>
